module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/home-slides/ig-05-87f1ab71f661f7d51e18a75e8edbe08f.jpg";